const PASSWORD_MIN_LENGTH = 6;

export function validatePassword(password: string | undefined): boolean {
    if (password) {
        return password.length >= PASSWORD_MIN_LENGTH;
    }
    return false;
}

export function validateVerificationCode(code: string | undefined): boolean {
    if (code) {
        return code.length === 6;
    }
    return false;
}
